// shared/ko/bindings/date.js
import ko from 'knockout';

const dateBinding = {
    update: function (element, valueAccessor, allBindings) {
        const rawValue = ko.unwrap(valueAccessor()); // expects YYYY-MM-DD
        const locale = ko.unwrap(allBindings.get('locale')) ?? navigator.language;
        const formatOptions = allBindings.get('formatOptions') ?? { dateStyle: 'medium' };

        if (!rawValue) {
            element.textContent = '-';
            return;
        }

        const date = new Date(rawValue);
        if (isNaN(date.getTime())) {
            element.textContent = '-';
            return;
        }

        const formatter = new Intl.DateTimeFormat(locale, formatOptions);
        element.textContent = formatter.format(date);
    }
};

ko.bindingHandlers.date = dateBinding;

export default dateBinding;
